export default "__VITE_ASSET__BV2g7JWh__"